var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box__primary box__dark text-center box__header-title",class:{'box__header-title-slim': _vm.$route.meta.slimHeader}},[_c('h2',[_vm._v("Trabalhar")])])}
var staticRenderFns = []

export { render, staticRenderFns }